var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 6.25L8.26436 9.76245C8.88031 10.2904 9.18829 10.5544 9.53368 10.655C9.83809 10.7437 10.1615 10.7437 10.4659 10.655C10.8113 10.5544 11.1193 10.2904 11.7352 9.76245L15.8331 6.25",
    stroke: "current",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.6753L15.8333 13.7586",
    stroke: "current",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 13.75L6.24982 11.6667",
    stroke: "current",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1665 6.41664C2.1665 5.94169 2.16689 5.61554 2.18755 5.36271C2.20773 5.11571 2.24473 4.98303 2.29366 4.887C2.40551 4.66748 2.58399 4.48901 2.80351 4.37716C2.89953 4.32823 3.03221 4.29123 3.27921 4.27105C3.53204 4.25039 3.85819 4.25 4.33315 4.25H15.6664C16.1413 4.25 16.4675 4.25039 16.7203 4.27105C16.9673 4.29123 17.1 4.32823 17.196 4.37716L17.423 3.93165L17.196 4.37716C17.4155 4.48901 17.594 4.66748 17.7059 4.887C17.7548 4.98303 17.7918 5.11571 17.812 5.36271C17.8326 5.61554 17.833 5.94169 17.833 6.41664V13.5833C17.833 14.0582 17.8326 14.3844 17.812 14.6372C17.7918 14.8842 17.7548 15.0169 17.7059 15.1129C17.594 15.3324 17.4155 15.5109 17.196 15.6227C17.1 15.6717 16.9673 15.7087 16.7203 15.7288C16.4675 15.7495 16.1413 15.7499 15.6664 15.7499H4.33315C3.85819 15.7499 3.53205 15.7495 3.27921 15.7288C3.03221 15.7087 2.89953 15.6717 2.80351 15.6227C2.58399 15.5109 2.40551 15.3324 2.29366 15.1129C2.24473 15.0169 2.20773 14.8842 2.18755 14.6372C2.16689 14.3844 2.1665 14.0582 2.1665 13.5833V6.41664Z",
    stroke: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.022008aa.svg";
export { ForwardRef as ReactComponent };